exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".balance-box[data-v-0cb51812]{position:relative;flex:1 0 0}.balance-box[data-v-0cb51812]  .el-input__inner{height:.48rem;background:#f7f8fa;border-color:#f7f8fa}.balance-box[data-v-0cb51812]  .el-input-group__append{background:#f7f8fa;border-color:#f7f8fa;font-size:.18rem;color:#aaa}.detail-item[data-v-0cb51812]{margin-bottom:.35rem}", ""]);

// exports
